import { useState, useEffect } from 'react'
import { C, R, F } from '../lib/designTokens'
import { useNavigationContextIdentity } from '../context/NavigationContextIdentity'
import * as pk from '../services/productKnowledgeService'

// Small, quiet doorway into Product Knowledge from the current CostSpace
// screen. Resolves context via the existing NavigationContextIdentity +
// catalog_resolve_context() -- renders nothing when unmapped, never
// fabricates a mapping, never blocks the underlying page while resolving.
//
// onOpenProductKnowledge(target): called with { mode, key } when clicked --
// App.jsx decides how to actually navigate to the Product Knowledge page.
export default function ProductKnowledgeContextLink({ onOpenProductKnowledge }) {
  const ctx = useNavigationContextIdentity()
  const [resolved, setResolved] = useState(null) // null = not yet known / unmapped

  useEffect(() => {
    if (!ctx) return
    let cancelled = false
    pk.resolveContext({ route: ctx.route, navKey: ctx.nav_key, tabKey: ctx.tab_key })
      .then(r => { if (!cancelled) setResolved(r?.mapped ? r : null) })
      .catch(() => { if (!cancelled) setResolved(null) }) // fail quietly -- never break the host page
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx?.nav_key, ctx?.tab_key])

  if (!resolved?.mapped || !resolved.screen?.key) return null

  const workflowKey = resolved.workflows?.[0]?.key || null

  function open() {
    if (workflowKey) onOpenProductKnowledge({ mode: 'workflow', key: workflowKey })
    else onOpenProductKnowledge({ mode: 'unit', key: resolved.screen.key })
  }

  return (
    <button onClick={open}
      title="Open in Product Knowledge / افتح في قاعدة المعرفة"
      style={{
        height: 32, padding: '0 10px', display: 'flex', alignItems: 'center', gap: 6,
        background: 'transparent', border: `1px solid ${C.green}`, borderRadius: R.btn,
        color: C.green, cursor: 'pointer', fontSize: 11, fontWeight: 600, transition: 'all .12s',
      }}
      onMouseEnter={e => { e.currentTarget.style.background = C.greenBg }}
      onMouseLeave={e => { e.currentTarget.style.background = 'transparent' }}>
      📘 Guidance / الإرشاد
    </button>
  )
}
